import { usePhoneClickTracking } from '@/hooks/useAnalytics';

const AnalyticsProvider = () => {
  usePhoneClickTracking();
  return null;
};

export default AnalyticsProvider;
